define(function (require) {


    function Enum(itemsArray) {
        for (var i = 0; i < itemsArray.length; i++) {
            this[itemsArray[i].name] = itemsArray[i].val;
        }
    }

    return Enum;
});